module.exports = __webpack_public_path__ + "img/cfp_primary_data_merge_active.bf964849.svg";